import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

// Import modal
import AddGradeModal from "../modals/AddGradeModal";

const GradeEntry = () => {
  const routes = all_routes;
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedExam, setSelectedExam] = useState("");

  // Mock data
  const mockClasses = [
    { id: 1, name: "Grade 10A - Mathematics" },
    { id: 2, name: "Grade 11B - Physics" },
    { id: 3, name: "Grade 9C - Mathematics" },
  ];

  const mockExams = [
    { id: 1, name: "Mid-term Exam", date: "2024-07-15", maxMarks: 100 },
    { id: 2, name: "Quiz 1", date: "2024-07-10", maxMarks: 25 },
    { id: 3, name: "Assignment 1", date: "2024-07-05", maxMarks: 50 },
  ];

  const mockStudents = [
    {
      id: 1,
      name: "Alice Johnson",
      rollNo: "A001",
      grade: 85,
      submitted: true,
    },
    { id: 2, name: "Bob Smith", rollNo: "A002", grade: 78, submitted: true },
    { id: 3, name: "Carol Davis", rollNo: "A003", grade: "", submitted: false },
    { id: 4, name: "David Wilson", rollNo: "A004", grade: 92, submitted: true },
  ];

  const handleAddGrades = () => {
    if (!selectedClass || !selectedExam) {
      alert("Please select both class and exam first");
      return;
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherDashboard}>Teacher Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Grade Entry</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Grade Entry Form */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Grade Entry & Management</h4>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm"
                      data-bs-toggle="modal"
                      data-bs-target="#addGradeModal"
                      onClick={handleAddGrades}
                    >
                      <i className="ti ti-plus me-1"></i>Add Grades
                    </button>
                    <button className="btn btn-success btn-sm">
                      <i className="ti ti-device-floppy me-1"></i>Save All
                      Grades
                    </button>
                    <button className="btn btn-outline-primary btn-sm">
                      <i className="ti ti-download me-1"></i>Export
                    </button>
                  </div>
                </div>

                {/* Selection */}
                <div className="card-body border-bottom">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">
                        Select Class <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={selectedClass}
                        onChange={(e) => setSelectedClass(e.target.value)}
                      >
                        <option value="">Choose a class...</option>
                        {mockClasses.map((cls) => (
                          <option key={cls.id} value={cls.name}>
                            {cls.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Select Exam/Assessment{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={selectedExam}
                        onChange={(e) => setSelectedExam(e.target.value)}
                      >
                        <option value="">Choose an exam...</option>
                        {mockExams.map((exam) => (
                          <option key={exam.id} value={exam.name}>
                            {exam.name} - Max: {exam.maxMarks}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">&nbsp;</label>
                      <button
                        className="btn btn-outline-secondary w-100"
                        disabled={!selectedClass || !selectedExam}
                      >
                        Load Students
                      </button>
                    </div>
                  </div>
                </div>

                {/* TODO */}
                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6>
                      <i className="ti ti-info-circle me-2"></i>TODO: Connect to
                      grades API
                    </h6>
                    <ul className="mb-0">
                      <li>Fetch exam/assessment data</li>
                      <li>Save and validate grade entries</li>
                      <li>Calculate grade statistics</li>
                      <li>Generate grade reports</li>
                    </ul>
                  </div>
                </div>

                {/* Grade Entry Table */}
                {selectedClass && selectedExam && (
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <p>
                          <strong>Class:</strong> {selectedClass}
                        </p>
                        <p>
                          <strong>Assessment:</strong> {selectedExam}
                        </p>
                      </div>
                      <div className="col-md-6 text-end">
                        <p>
                          <strong>Total Students:</strong> {mockStudents.length}
                        </p>
                        <p>
                          <strong>Grades Entered:</strong>{" "}
                          {mockStudents.filter((s) => s.grade !== "").length}
                        </p>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Roll No</th>
                            <th>Student Name</th>
                            <th>Grade/Marks</th>
                            <th>Letter Grade</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mockStudents.map((student) => (
                            <tr key={student.id}>
                              <td>{student.rollNo}</td>
                              <td>{student.name}</td>
                              <td>
                                <div
                                  className="input-group"
                                  style={{ width: "120px" }}
                                >
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    defaultValue={student.grade}
                                    placeholder="0"
                                    min="0"
                                    max="100"
                                  />
                                  <span className="input-group-text">/100</span>
                                </div>
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    Number(student.grade) >= 90
                                      ? "badge-soft-success"
                                      : Number(student.grade) >= 80
                                      ? "badge-soft-primary"
                                      : Number(student.grade) >= 70
                                      ? "badge-soft-warning"
                                      : Number(student.grade) >= 60
                                      ? "badge-soft-info"
                                      : "badge-soft-danger"
                                  }`}
                                >
                                  {Number(student.grade) >= 90
                                    ? "A"
                                    : Number(student.grade) >= 80
                                    ? "B"
                                    : Number(student.grade) >= 70
                                    ? "C"
                                    : Number(student.grade) >= 60
                                    ? "D"
                                    : student.grade !== ""
                                    ? "F"
                                    : "-"}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    student.submitted
                                      ? "badge-soft-success"
                                      : "badge-soft-warning"
                                  }`}
                                >
                                  {student.submitted ? "Submitted" : "Pending"}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addGradeModal"
                                  >
                                    <i className="ti ti-edit"></i>
                                  </button>
                                  <button className="btn btn-sm btn-outline-success">
                                    <i className="ti ti-check"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Grade Statistics */}
                    <div className="row mt-4">
                      <div className="col-md-12">
                        <h6>Grade Statistics</h6>
                        <div className="row">
                          <div className="col-md-2">
                            <div className="text-center p-2 border rounded">
                              <h5 className="text-success">1</h5>
                              <small>A (90-100)</small>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-center p-2 border rounded">
                              <h5 className="text-primary">2</h5>
                              <small>B (80-89)</small>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-center p-2 border rounded">
                              <h5 className="text-warning">0</h5>
                              <small>C (70-79)</small>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-center p-2 border rounded">
                              <h5 className="text-info">0</h5>
                              <small>D (60-69)</small>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-center p-2 border rounded">
                              <h5 className="text-danger">0</h5>
                              <small>F (0-59)</small>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="text-center p-2 border rounded">
                              <h5 className="text-muted">1</h5>
                              <small>Pending</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Bulk Actions */}
                    <div className="d-flex gap-2 mt-3">
                      <button className="btn btn-success">
                        <i className="ti ti-device-floppy me-1"></i>Save All
                      </button>
                      <button className="btn btn-outline-warning">
                        <i className="ti ti-bell me-1"></i>Notify Parents
                      </button>
                      <button className="btn btn-outline-primary">
                        <i className="ti ti-printer me-1"></i>Print Report
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <AddGradeModal />
    </>
  );
};

export default GradeEntry;
